import { useLocation } from "react-router-dom";
import { useEffect } from "react";
import { Search } from "lucide-react";
import { SEO, seoConfig } from "@/hooks/useSEO";

const NotFound = () => {
  const location = useLocation();

  useEffect(() => {
    console.error("404 Error: User attempted to access non-existent route:", location.pathname);
  }, [location.pathname]);

  return (
    <div className="flex min-h-screen items-center justify-center bg-muted">
      <SEO {...seoConfig.notFound} />
      <div className="text-center">
        <div className="mb-6 flex justify-center">
          <Search className="h-16 w-16 text-primary opacity-60" />
        </div>
        <h1 className="mb-4 text-4xl font-bold">404</h1>
        <p className="mb-4 text-xl text-muted-foreground">Oups ! Page introuvable</p>
        <a href="/" className="text-primary underline hover:text-primary/90">
          Retour à l'accueil
        </a>
      </div>
    </div>
  );
};

export default NotFound;
